export default "__VITE_ASSET__VvQLQQwH__"